var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _rect9, _rect0, _rect1, _rect10, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleItemsSelectOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 122,
    viewBox: "0 0 162 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C2.51472 0.5 0.5 2.51472 0.5 5V117C0.5 119.485 2.51471 121.5 5 121.5H157C159.485 121.5 161.5 119.485 161.5 117V5C161.5 2.51472 159.485 0.5 157 0.5H5Z",
    fill: "#F8F8F8",
    stroke: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 94,
    width: 22,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 66.6973,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 75.4121,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 80.127,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 21H15.5V56H50.5V21ZM48.9899 22.5742H17.0762V54.5117H48.9899V22.5742Z",
    fill: "#68C598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7717 45.3261L28.8369 34.9238L18.8369 49.9238H32.5533L32.5 50H46.5L39.5 40L35.7717 45.3261Z",
    fill: "#68C598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5467 37.0108C43.7816 37.0108 45.5933 35.2175 45.5933 33.0054C45.5933 30.7933 43.7816 29 41.5467 29C39.3117 29 37.5 30.7933 37.5 33.0054C37.5 35.2175 39.3117 37.0108 41.5467 37.0108Z",
    fill: "#68C598"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 66.4297,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 75.1445,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 79.8594,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 94,
    width: 22,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5 21H63.5V56H98.5V21ZM96.9899 22.5742H65.0762V54.5117H96.9899V22.5742Z",
    fill: "#68C598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7717 45.3261L76.8369 34.9238L66.8369 49.9238H80.5533L80.5 50H94.5L87.5 40L83.7717 45.3261Z",
    fill: "#68C598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5467 37.0108C91.7816 37.0108 93.5933 35.2175 93.5933 33.0054C93.5933 30.7933 91.7816 29 89.5467 29C87.3117 29 85.5 30.7933 85.5 33.0054C85.5 35.2175 87.3117 37.0108 89.5467 37.0108Z",
    fill: "#68C598"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 67,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 75.7148,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 80.4297,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 94,
    width: 22,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.5 21H111.5V56H146.5V21ZM144.99 22.5742H113.076V54.5117H144.99V22.5742Z",
    fill: "#68C598"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.772 45.3261L124.837 34.9238L114.837 49.9238H128.553L128.5 50H142.5L135.5 40L131.772 45.3261Z",
    fill: "#68C598"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.547 37.0108C139.782 37.0108 141.593 35.2175 141.593 33.0054C141.593 30.7933 139.782 29 137.547 29C135.312 29 133.5 30.7933 133.5 33.0054C133.5 35.2175 135.312 37.0108 137.547 37.0108Z",
    fill: "#68C598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleItemsSelectOne);
export default __webpack_public_path__ + "static/media/multiple-items-select-one.8c3e06607bc862848c61e1658606ac03.svg";
export { ForwardRef as ReactComponent };